
































































































































import { Vue, Component, Prop } from "vue-property-decorator";

import CustomContainer from "./Globals/CustomContainer.vue";
import CustomText from '@/components/Globals/CustomText.vue';
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomImage from '@/components/Globals/CustomImage.vue';

import almostDone from '@/mixins/UGC/almostDone';

@Component({
  components: {
    CustomContainer,
    CustomText,
    CustomButton,
    CustomImage
  },
  mixins: [almostDone]
})
export default class UgcAlmostDone extends Vue {
}
